import axios from "axios";
import clonedeep from "lodash.clonedeep";
import Cookies from "universal-cookie";
import { getAccessToken, setSSOValue, clearCookies } from "./constants";

const axiosInstance = axios.create({
  baseURL: '',
});


const getAPIEndpoint = () => localStorage.getItem('API_ENDPOINT')
const getEndpoint = () => '/KPIIPModule/api/v1/XELSYSADM'
const getCatalogEndpoint = () => '/workflow/api/v1'
const logoutUrl = localStorage.getItem("logoutURL");
const getRequestsUrl = () => '/workflow'
const getCertificationUrl = () => localStorage.getItem('CERTIFICATION_API_ENDPOINT')
const isUserCertification = () => localStorage.getItem('IS_USER_CERTIFICATION')
export const isSignOffDataRequired = () => localStorage.getItem('IS_SIGN_OFF_DATA_REQUIRED')

const cookies = new Cookies();

export const getTenantId = () =>{
  return cookies.get('REGISTERED_APPNAME')
}

export const getUserName = () => {
 return  cookies.get('LOGGEDIN_USERID');
}

export const getDisplayName = () => {
 return localStorage.getItem('user-display-name') || ''
}

export const isHelpDeskAdmin = () => {
 const role = cookies.get('USER_ADMIN_ROLE') || ""
 return (role || "").includes("HelpDesk")
}

export const getStatusList = () => {
  const array = localStorage.getItem('STATUS_LIST') || {}
  return JSON.parse(array)
}

export const getProvideInfoMessage = () => localStorage.getItem('PROVIDE_INFO_MESSAGE') || ""

export const getRecordLength = () => localStorage.getItem('RECORD_LENGTH') || 3

export const getAuthHeaders = () => {
  return {
    'Authorization': `Bearer ${getAccessToken()}`,
    'oim_remote_user': cookies.get('LOGGEDIN_USERID') || "",
    'lastLogin': cookies.get('LAST_LOGIN') || "",
    'Content-Type': 'application/json'
  }
};

export const getRefreshAuthHeaders = () => {
  return {
    'refreshToken': cookies.get('REFRESH_TOKEN') || "",
    'Cookie': cookies.get('JWT_ACCESSTOKEN1') + cookies.get('JWT_ACCESSTOKEN2') || ""
  }
};

const getUserNameHeader = () => {
  return {
    'Authorization': `Basic ${cookies.get('USER_PWD_TOKEN') || ""}`,
  };
};

const returnPromise = async (data, needError) => {
  return await new Promise((resolve, reject) => setTimeout(() => needError ? reject({error: true}) : resolve(data), 2000));
}

const auth = { Authorization: `Bearer YUwzeWxta0RjcHAxYnY5am5OTW80cmJKVDQ3cktoOGpSK0RXWm84MlN5UXZtenQwSUo2WXg3bFRuakw4VEZmNQ==` }
const saveAuth = { Authorization: `Bearer bVZRQVNacXhpTjdWMXZEWXFsK0dKb215emZwUjR2Lzh6UVB3YVhQNTB6ZVZlL3B0dTRlQS9iTzI2cXBjUVpZM0RkY2Nsenk3RDVBeQp0RUF5czYyS05RPT0=` }

// const explicitLogout = () => {
//   // clear local storage and rediect use to login page
//   window.location.href = `/iga/${getTenantId()}/certification`
//   clearCookies()
//   localStorage.clear()
// }

const explicitLogout = () => {
  // clear local storage and rediect use to login page
  const cookies = new Cookies();
  cookies.remove('USER_PWD_TOKEN',  { path: '/' });
  cookies.remove('JWT_ACCESSTOKEN1', { path: '/' });
  cookies.remove('JWT_ACCESSTOKEN2', { path: '/' });
  cookies.remove('REGISTERED_APPNAME', { path: '/' });
  cookies.remove('LOGGEDIN_USERID', { path: '/' });
  cookies.remove('LAST_LOGIN', { path: '/' });
  cookies.remove('USER_ADMIN_ROLE', { path: '/' });
  // const logoutURL= logoutUrl();
  const newWindow = window.open(logoutUrl, '_blank');
  setTimeout(() => newWindow.close(), 3000);

  setTimeout(() => {
    window.location.reload()
  }, 3100)
  // clearCookies();
  // localStorage.clear();
  // window.location.href = `/iga/${getTenantId()}/certification`;
  clearCookies()
  localStorage.clear()

};

// const refreshToken = () => {
//   let retry = 0

//   axiosInstance.interceptors.response.use(
//       (response) => response,
//       async (error) => {
//         const originalRequest = error.config
//         //Handle 401 and 302 unauthorized status code
//         // console.log({error})
//         if (
//             error &&
//             ((error.response &&
//                 (error.response.status === 401)) ||
//                 error.message === 'Network Error')
//         ) {
//           if (retry === 2) {
//             retry = 0
//             explicitLogout()
//           } else {
//             try {
//               const dataConfig = {
//                 headers: {
//                   ...getRefreshAuthHeaders(),
//                   // ...(headers || {}),
//                 },
//               }
//               const refreshObject = await axios.post(
//                   `${getAPIEndpoint()}/KPIIPModule/api/v1/${getTenantId()}/refreshToken${setSSOValue('')}`,
//                   {},
//                   dataConfig
//               )

//               const { loginDateAndTime, userName, refreshToken } = refreshObject.data || {}

//               cookies.set('JWT_ACCESSTOKEN', refreshObject.data.cookies || "", { path: '/' });
//               cookies.set('LOGGEDIN_USERID', userName, { path: '/' });
//               cookies.set('LAST_LOGIN', loginDateAndTime || "", { path: '/' });
//               cookies.set('REFRESH_TOKEN', refreshToken || "", { path: '/' });

//               retry++
//               originalRequest.headers['Authorization'] =
//                   'Bearer ' + refreshObject.data.cookies
//               originalRequest.headers['lastLogin'] = loginDateAndTime
//               return axiosInstance(originalRequest)
//             } catch (e) {
//               explicitLogout()
//             }
//           }
//         }
//         return Promise.reject(error)
//       }
//   )
// }

const refreshToken = () => {
  let retry = 0;

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error && ((error.response && error.response.status === 401) || error.message === "Network Error")) {
        // explicitLogout directly for 401 errors
        // explicitLogout();
        // return Promise.reject(error);
    //  if (retry === 2) {
    //    retry = 0;
    //    explicitLogout();
   //   } else {
        try {

          if(cookies.get("REFRESH_TOKEN") === undefined || cookies.get("REFRESH_TOKEN") === ''){
            explicitLogout();
          }else{
          const dataConfig = {
            headers: {
              // ...getRefreshAuthHeaders(),
              refreshToken: cookies.get("REFRESH_TOKEN") || "",
              Cookie: cookies.get("JWT_ACCESSTOKEN") || "",
            },
          };
          const refreshObject = await axios.post(
            `${getAPIEndpoint()}/KPIIPModule/api/v1/${getTenantId()}/refreshToken${setSSOValue('')}`,
            {},
            dataConfig
          );
          if(refreshObject === null || refreshObject === undefined) {
            explicitLogout();
            return Promise.reject(error);
          }else{
          const { loginDateAndTime, userName, refreshToken } = refreshObject.data || {};

          cookies.set("JWT_ACCESSTOKEN", refreshObject.data.cookies || "", {
            path: "/",
          });
          cookies.set("LOGGEDIN_USERID", userName, { path: "/" });
          cookies.set("LAST_LOGIN", loginDateAndTime || "", { path: "/" });
          cookies.set("REFRESH_TOKEN", refreshToken || "", { path: "/" });

          retry++;
          originalRequest.headers["Authorization"] = "Bearer " + refreshObject.data.cookies;
          originalRequest.headers["lastLogin"] = loginDateAndTime;
          return axiosInstance(originalRequest);
           }
         }
        } catch (e) {
          explicitLogout();
        }
     // }
     
    }
      return Promise.reject(error);
    }
  );
};


export class ApiService {

  static async getData(url, headers, cancelToken, data) {
    const config = {
      headers: {
        ...getAuthHeaders(),
        ...(headers || {}),
      },
    };
    if (data) {
      config.data = data;
    }
    if (cancelToken && cancelToken.token) {
      config.cancelToken = cancelToken.token;
    }

    refreshToken()

    const response = await axiosInstance.get(setSSOValue(url), config).catch((err) => {
      data = {error: 'something went wrong'};
    });
    return data || response.data;
  }

  static async postMethod(url, data, headers, cancelToken) {
    const config = {
      headers: {
        ...getAuthHeaders(),
        ...(headers || {})
      }
    };
    if (cancelToken && cancelToken.token) {
      config.cancelToken = cancelToken.token;
    }

    refreshToken()

    let resData = '';
    const response = await axiosInstance.post(setSSOValue(url), data, config).catch(thrown => {
      if (thrown.toString() === 'Cancel') {
        resData = 'cancel';
      } else {
        resData = {error: 'something went wrong'};;
      }
    });
    return resData || response.data;
  }

  static async patchMethod(url, data, headers, cancelToken) {
    const config = {
      headers: {
        ...(headers || {})
      }
    };
    if (cancelToken && cancelToken.token) {
      config.cancelToken = cancelToken.token;
    }

    refreshToken()

    let resData = '';
    const response = await axiosInstance.patch(setSSOValue(url), data, config).catch(thrown => {
      if (thrown.toString() === 'Cancel') {
        resData = 'cancel';
      } else {
        resData = {error: 'something went wrong'};;
      }
    });
    return resData || response.data;
  }

  static async putMethod(url, data, headers) {
    const config = {
      headers: {
        ...getAuthHeaders(),
        ...(headers || {})
      }
    };

    refreshToken()

    let resData = '';
    const response = await axiosInstance.put(setSSOValue(url), data, config).catch(err => {
      resData = {error: 'something went wrong'};
    });
    return resData || response.data;
  }

  static async deleteMethod(url, data, headers) {
    const config = {
      headers: {
        ...getAuthHeaders(),
        ...(headers || {})
      },
      data
    };

    refreshToken()

    let resData = '';
    const response = await axiosInstance.delete(setSSOValue(url), config).catch(err => {
      resData = {error: 'something went wrong'};
    });
    return resData || response.data;
  }

  static async GetAllIdentityUsers() {
    // return await returnPromise(usersList);
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/selfservice/reportees`);
  }

  static async getAllUsers() {
    // return await returnPromise(usersList);
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/getallusers`);
  }

  static async getSpecificUser(body) {
    return await ApiService.postMethod(`${getAPIEndpoint()}/KPIIPModule/api/v1/${getTenantId()}/Users/reassingmentuser`, body);
  }

  static async GetProfileDetails() {
    // return await returnPromise(clonedeep(profileDetails));
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/selfservice/profileCompleteDetails`);
  }

  static async getAgencyDetails() {
    // return await returnPromise(clonedeep(profileDetails));
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/agencyDetails`);
  }

  static async getRecommendationList(userId) {
    // return await returnPromise(clonedeep(catelogs));
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/recommendation/${userId}`);
  }

  static async getUserCloneList(userKey) {
    // return await returnPromise(clonedeep(catelogs));
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/clone/${userKey}`);
  }

  static async updateProfileDetails(userId, body) {
    // return await returnPromise({ "response": "success"});
    return await ApiService.putMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${userId}`, body);
  }

  static async localLogin(body) {
    // return {
    //   "cookies": "Z0hlUldFQlpYZ0xYckxsV09sa2VDL2h3MTJQdE54MzVyNmQxczM3ekdacTdaZFZMcVJRQnI3enJlRWMxb2FnV0RkY2Nsenk3RDVBeQp0RUF5czYyS05RPT0=",
    //   "loginDateAndTime": "21-7-2020 04:59:02",
    //   "userName": "XELSYSADM"
    // };
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/login`, body);
  }

  static async getAdminUserRole() {
    // return await returnPromise({ "userOperationalRole": "HelpDesk" });
    // return await returnPromise({ "userOperationalRole": "Manager" });
    // return await returnPromise({ "userOperationalRole": "Employee" });
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/selfservice/getOperationalRole`);
  }

  static async getSSOAdminUserRole() {
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/selfservice/getOperationalRole${setSSOValue()}`);
  }

  static async resetPasswordForUser(userName, body) {
    // return await returnPromise({ "response": "success"});
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${userName}/resetpassword`, body);
  }

  static async changePassword(body) {
    // return await returnPromise({ "response": "success"});
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/selfService/changepassword`, body);
  }

  static async userLockUnlock(userId, value) {
    // return await returnPromise({ "response": "success"});
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${userId}/lockunlock?lock=${value}`, {});
  }

  static async userEnableDisable(userId, value) {
    // return await returnPromise({ "response": "success" });
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${userId}/enabledisable?enable=${value}`, {});
  }

  static async userDelete(userId) {
    // return await returnPromise({ "response": "success" });
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${userId}/delete`, {});
  }

  static async GetAllProxy() {
    // return await returnPromise(proxyList);
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/selfservice/getProxy`);
  }

  static async deleteProxy(proxyId) {
    // return await returnPromise(proxyList);
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/selfservice/removeProxy?proxyId=${proxyId}`);
  }

  static async addProxy(query) {
    // return await returnPromise(proxyList);
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/selfservice/addProxy?${query}`);
  }

  static async getCatalogs(id) {
    // return await returnPromise(catelogs);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/catalogs${id ? `/${id}` : ""}`);
  }

  static async getRoles() {
    // return await returnPromise(rolesList);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/roles`);
  }

  static async getApplications() {
    // return await returnPromise(applicationsList);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/applications`);
  }

  static async getEntitlementForApplication(appCatalogId) {
    // return await returnPromise(entitlementForApplication);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/entitlements/${appCatalogId}`);
  }

  static async getCatalogsDetails(catalogId) {
    // return await returnPromise(catalogDetails);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/catalogs/details/${catalogId}`);
  }

  static async getConfidenceLevelData() {
    // return await returnPromise(confidenceLevelData);
    return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/confidenceLevelData`);
  }

  static async postConfidenceLevelData(body) {
    // return await returnPromise(confidenceLevelData);
    return await ApiService.postMethod(`${getCertificationUrl()}/${getTenantId()}/confidenceLevelData`, body);
  }

  static async getRoleDetails(roleName) {
    // return await returnPromise(getRoleDetails);
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/roleDetails/${roleName}`);
  }

  static async submitCatalogs(body) {
    // return await returnPromise({
    //   "status": "SUCCESS",
    //   "httpStatus": "200",
    //   allAlreadyAssigned: true,
    //   // "alreadyAssignedList": [
    //   //   {
    //   //     "objectID": "1",
    //   //     "objectName": "DBUMApp",
    //   //     "objectType": "ApplicationInstance",
    //   //     "requestedForDisplayName": "First041 Last041",
    //   //     "requestedForID": "test004"
    //   //   },
    //   //   {
    //   //     "objectID": "4",
    //   //     "objectName": "CREATE ANY ASSEMBLY",
    //   //     "objectType": "Entitlement",
    //   //     "requestedForDisplayName": "First041 Last041",
    //   //     "requestedForID": "test004"
    //   //   }
      // ]
    // });
    return await ApiService.postMethod(`${getAPIEndpoint()}${getCatalogEndpoint()}/catalogs`, body);
  }

  static async getApplicationList(userId) {
    // return await returnPromise(applications);
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/${userId}/applications`);
  }

  static async getEntitlementList(userId) {
    // return await returnPromise(entitlements);
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/Users/${userId}/entitlements`);
  }

  static async deleteEntitlement(id, query) {
    // return await returnPromise(entitlements);
    return await ApiService.putMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${id}/entitlements/revoke${query}`);
  }

  static async deleteOIGRoleEntitlement(userId, roleName) {
    // return await returnPromise(entitlements);
    return await ApiService.putMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${userId}/role/revoke/${roleName}`);
  }

  static async deleteAccount(id, query) {
    // return await returnPromise(entitlements);
    return await ApiService.putMethod(`${getAPIEndpoint()}${getEndpoint()}/Users/${id}/applications/revoke${query}`);
  }

  static async getTrackRequests(userId, count) {
    // return await returnPromise(trackRequests);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/trackRequest/${userId}${count > 0 ? `/${count}` : ''}`);
  }

  static async getRequestHistoryList(requestId) {
    // return await returnPromise(trackRequests);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/requestDetailsById/${requestId}`);
  }

  static async getApproveAccessList(count) {
    // return await returnPromise(approveAccess);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/getApproveAccess${count > 0 ? `/${count}` : ''}`);
  }

  static async getApproveAccessAnalyticsList() {
    // return await returnPromise(approveAccess);
    return await ApiService.getData(`${getAPIEndpoint()}${getCatalogEndpoint()}/getApproveAccessAnalytics`);
  }

  static async submitApproveAccessList(body) {
    // return await returnPromise(approveAccess);
    return await ApiService.putMethod(`${getAPIEndpoint()}${getCatalogEndpoint()}/updateRequest`, body);
  }

  static async deleteTrackItem(requestId) {
    // return await returnPromise({});
    return await ApiService.putMethod(`${getAPIEndpoint()}${getCatalogEndpoint()}/deleteRequest/${requestId}`, {});
  }

  static async getCertificationsList(isSignOffDataRequired) {
    // return await returnPromise(certificationsList);
    // return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/getCertifications/${getUserName()}?isSignOffDataRequired=${isSignOffDataRequired}`,  /* auth */ );
    return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/${String(isSignOffDataRequired) === "false" ? "getCertifications" : "getSignOffCertifications"}/${getUserName()}`,  /* auth */ );
  }

  static async getCertificateUsers(certificationId, taskId, isSignOff) {
    // return await returnPromise(certificationsUsers);
    let query = (isSignOff || "") ? "?isSignOffDataRequired=true" : ""
    return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/getCertificateUsers/${certificationId}/${taskId}${query}`, /* auth */ );
  }

  static async getUserDetails(certiId, taskId, id) {
    // return await returnPromise(certificationsUserDetails);
    return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/getUserDetails/${certiId}/${taskId}/${id}`,  /* auth */ );
  }

  static async certificationAction(userName, certiId, taskId, lineId, data) {
      if(isUserCertification() === "true") {
          return await ApiService.putMethod(`${getCertificationUrl()}/${getTenantId()}/action/${getUserName()}/${userName}/${certiId}/${taskId}/${lineId}`, data,  /* auth */ );
      } else {
          return await ApiService.putMethod(`${getAPIEndpoint()}/${getEndpoint()}/certificationAction/${certiId}/${taskId}/${lineId}`, data );
      }
  }

  static async getPeerAnalytics(userName) {
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/${getTenantId()}/user/peerAnalytics/${userName}`);
  }

  static async getCurrentUserDetails(userName = '') {
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/${getTenantId()}/Users/${userName.toUpperCase()}`);
  }

  static async onSignOffRequired(certId) {
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/${getTenantId()}/isSignOffRequired/${certId}`);
  }

  static async certificationSignOff(data) {
    return await ApiService.putMethod(`${getCertificationUrl()}/${getTenantId()}/certificationsAction`, data,  /* auth */ );
  }

  static async certificationUserReassigning(body) {
    return await ApiService.putMethod(`${getCertificationUrl()}/${getTenantId()}/certificationsAction/user`, body,  /* auth */ );
    // return await ApiService.putMethod(`${getAPIEndpoint()}/KPIIPModule/api/v1/${getTenantId()}/certificationAction/${id}/${ids}/000`, body,  /* auth */ );
  }

  static async certificationUserAction(data) {
    return await ApiService.putMethod(`${getCertificationUrl()}/${getTenantId()}/certificationsAction/user`, data,   /* auth */ );
  }

  static async getCertifications(count) {
    return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/getCertifications/${getUserName()}/${count}`,  /* auth */ );
  }

  static async getOfflineCertificationDetails(certificationId, taskId, isSignOff) {
    // return [
    //   {
    //     "certificationName": "User Certification [ First004 Last004 ]",
    //     "userName": "TEST049",
    //     "displayName": null,
    //     "roleName": "",
    //     "applicationName": "OUD App",
    //     "entitlement": "Payroll Application,",
    //     "action": "certified",
    //     "comments": "",
    //     "userId": 48,
    //     "roleId": 0,
    //     "applnId": 875,
    //     "entlId": 1755
    //   },
    //   {
    //     "certificationName": "User Certification [ First004 Last004 ]",
    //     "userName": "TEST049",
    //     "displayName": null,
    //     "roleName": "",
    //     "applicationName": "OUD App",
    //     "entitlement": "Payables Application",
    //     "action": "certified",
    //     "comments": "",
    //     "userId": 48,
    //     "roleId": 0,
    //     "applnId": 875,
    //     "entlId": 1743
    //   }
    // ]
    const query = (isSignOff || "") ? "?isSignOffDataRequired=true" : ""
    return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/getOfflineCertificationDetails/${certificationId}/${taskId}${query}`,  /* auth */ );
  }

  static async getOfflineUserCertificationDetails(certificationId, taskId) {
    // return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/getOfflineCertificationDetails/${certificationId}/${taskId}`,  /* auth */ );
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/identity/offlineUserDetails/${certificationId}`,  /* auth */ );
  }

  static async getOfflineUserAnalytics(certificationId) {
    // return await ApiService.getData(`${getCertificationUrl()}/${getTenantId()}/offlineUserAnalytics/${certificationId}`,  /* auth */ );
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/identity/offlineUserAnalytics/${certificationId}`,  /* auth */ );
  }

  static async getOwnerApplications(certificationId) {
    //  // http://aep.kapstonellc.com/KPIIPModule/api/v1/identity/appCertAccounts/{certId}
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/identity/appCertAccounts/${certificationId}`,  /* auth */ );
  }

  static async getOwnerApplicationsExpandedRow(certificationId, accountId) {
    // http://aep.kapstonellc.com/KPIIPModule/api/v1/identity/appCertEntitlements/{certId}/{accountId}
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/identity/appCertEntitlements/${certificationId}/${accountId}`,  /* auth */ );
  }

  static async getCertificationsEntitlement(certificationId) {
    // http://aep.kapstonellc.com/KPIIPModule/api/v1/identity/appCertEntitlements/{certId}/{accountId}
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/identity/applicationCertification/entitlementList/${certificationId}`);
  }

  static async getEntitlementsDetails(certificationId, entitlementName) {
    // http://aep.kapstonellc.com/KPIIPModule/api/v1/identity/appCertEntitlements/{certId}/{accountId}
    return await ApiService.getData(`${getAPIEndpoint()}/KPIIPModule/api/v1/identity/applicationCertification/detailsByEntitlement/${certificationId}/${entitlementName}`);
  }

  static async getCertificationInfo(certificationId) {
    // http://aep.kapstonellc.com/KPIIPModule/api/v1/identity/appCertEntitlements/{certId}/{accountId}
    return await ApiService.getData(`${getCertificationUrl()}/identity/getCertificateInfo/${certificationId}`);
  }

  static async uploadXLSAuthController(certificationId,  taskId, data) {
    // return await ApiService.postMethod(`http://b88931edd68a.ngrok.io/certification/api/v1/iga/submitOfflineCertification/54/9528259f-fcdb-475f-9a09-dbbce629706b`, data, { Authorization: `Bearer bVZRQVNacXhpTjdWMXZEWXFsK0dKb2NnQUFTcEUvckdaMENlNzFFRTdrWFFheHdBNUpmYVVuNzNHenVhbTZCakRkY2Nsenk3RDVBeQp0RUF5czYyS05RPT0=` });
    return await ApiService.postMethod(`${getCertificationUrl()}/${getTenantId()}/submitOfflineCertification/${certificationId}/${taskId}`, data,  /* auth */ );
    // http://3.128.125.41:8080/certification/api/v1/:tenantid/submitOfflineCertification//:certificationId/:taskId
  }

  static async getAdminCertificationList(role){
    // return await ApiService.getData(`http://aep.kapstonellc.com/KPIIPModule/api/v1/XELSYSADM/getAllAdminCerts/BOS`);
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/getAllAdminCerts/${role}`);
  }

  static async getAdminReports(startDate, endDate) {

    const queryParams = { startDate: [startDate], endDate: [endDate] };
    const queryString = Object.keys(queryParams)
    .map((key) => {
      if (Array.isArray(queryParams[key])) {
        return queryParams[key]
          .map(
            (value) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
      }
    })
    .join("&");
    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/getAdminReport?${queryString}`);
  }

  static async getCertificateUsersAdmin(certificationId) {

    return await ApiService.getData(`${getAPIEndpoint()}${getEndpoint()}/getCertificateUsers/${certificationId}`);
  }

  static async certReassign(userKey,certificationId,data){
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/reassigncert/${userKey}/${certificationId}`,data);
  }

  static async userReassign(userKey,certificationId,data){
    return await ApiService.postMethod(`${getAPIEndpoint()}${getEndpoint()}/reassignuser/${userKey}/${certificationId}`,data);
  }

}
